"use client";

import getGameContainer from "@casino/ui/Games/getGameContainer";
import { useGamePageData } from "@casino/ui/Games/hooks";
import { GameControlsRules } from "@workspace/frontend-ui";
import type { FC } from "react";

const RulesButton: FC = () => {
  const { t } = useGamePageData();

  const handleShowRules = () => getGameContainer()?.showRules();

  return (
    <GameControlsRules
      data-testid="rules-button"
      aria-label={t("game.controls.rules.show", "Game rules")}
      onClick={handleShowRules}
    />
  );
};

export default RulesButton;
